// Centralized admin base path resolver — resolves the configured admin URL
// (e.g. "/admin", "/secure-admin-xyz") from the pre-warmed window global or
// localStorage cache. Used by router, sidebar, redirects, and route guards.
//
// The value is set at HTML parse time by the pre-warm script in index.html
// (fetches GET /api/admin-path and stores on window.__NPC_ADMIN_PATH__ +
// localStorage["npc:adminpath:v1"]).
//
// Frontend public/customer routes are NEVER routed through this helper.

const DEFAULT = "/admin";

export function getAdminBase() {
  if (typeof window === "undefined") return DEFAULT;
  const w = window.__NPC_ADMIN_PATH__;
  if (w && typeof w === "string" && w.startsWith("/")) return w;
  try {
    const ls = localStorage.getItem("npc:adminpath:v1");
    if (ls && ls.startsWith("/")) return ls;
  } catch {}
  return DEFAULT;
}

// Build an admin route. `sub` may be omitted (base) or start with or without a slash.
export function adminUrl(sub = "") {
  const base = getAdminBase();
  if (!sub) return base;
  const s = sub.startsWith("/") ? sub : `/${sub}`;
  return `${base}${s}`;
}
